<template>
  <div class="container">
      To make use of the Glim frontend:
      <ol>
        <li>
          provide site info in json format like this:
          <pre>
  {
    name: 'concordance',
    url: 'https://concordance.apcom.ch',
    url_dev: 'http://localhost:3000',
    api: '/api/img',
    image_path: '/images/product_attributes/',
    image_width:200,
    image_height:200,
    cover: false,
  }
          </pre>
        </li>
        <li>
          provide api for authentication at '/api/login', return with token(Json web token). Here is the code of frontend for authentication.
          <pre>
  axios.post('/api/login', data)
    .then(({data}) => {
      localStorage.setItem("user-token", data.token);
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.token
      …
  })
          </pre>

          As for Laravel backend:<br>
          <a href="https://laravel.com/docs/5.8/passport" target="_blank" rel="noopener">Laravel Passport</a> for api authentication  <br>
          The APIs should allow <a href="https://enable-cors.org/" target="_blank" rel="noopener">Cross-Origin Resource Sharing</a><br>
          <a href="https://github.com/fruitcake/laravel-cors" target="_blank" rel="noopener">fruitcake/laravel-cors</a> to enable CORS.
        </li>
        <li>
          provide api for front end to fetch list of products with pagination at '/products'
          if search, get search text by key 'search'. <br>
          The return data should be like:
          <pre>
  {
    "current_page":1,
    "data":[{"id":5, "name":"Th\u00e9 chaud","images":[{"id":1, "image_path":"/images/products/46.3.jpeg", "cover": false},...], "reference":"11111",}...],
    "first_page_url":"http://localhost:3000/api/products?page=1",
    "last_page":1,
    "last_page_url":"http://localhost:3000/api/products?page=1",
    "next_page_url":null,
    "path":"http://localhost:3000/api/products",
    "per_page":"12",
    "prev_page_url":null,
    "total":5
  }
          </pre>
        </li>
        <li>
          provide api to receive image at '/images', the posted data is like:
          <pre>
  {
    'image': the image file
    'image_id': if to replace image
    'product_id':
  }
          </pre>
          the response should have data:
          <pre>
  {
    image:{
      'id':
      'image_path':
    }
  }
          </pre>
        </li>
        <li>
          provide api to delete image at '/images'.  the delete request has data 'image_id'
          the response should have data:
          <pre>
  {
    'status': success or failed
    'message': success message or failed message
  }
          </pre>
        </li>
        <li>
          provide api to update cover image at '/images'.  the patch request has data 'image_id', 
          the patch request has data like: 
          <pre>
  { 
    image_id: image.id
  }
          </pre>
          the response should have data:
          <pre>
  {
    'status': success or failed
    'message': success message or failed message
  }
          </pre>
        </li>
        <li>
          TODO: 
          <pre>
  as for Maison du Chasseur: for each product, the images should have 'cover' value. and api for to cover image. 
  as for Armis, the api to post image is not working: 
    Access to XMLHttpRequest at 'https://demos.armis.ch/api/images' from origin 'https://img.apcom.app' has been blocked by CORS policy
          </pre>

        </li>
      </ol>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  }
}
</script>
